import { useTranslation } from "react-i18next";

import { FilterOutlined } from "@ant-design/icons";
import { Row, Space } from "antd";
import { Button, CardContainer } from "components/elements";

function EmployeePerformanceAssessmentResults({ onFilter = () => {} }) {
  const { t } = useTranslation();

  return (
    <Space style={{ width: "100%" }} size={24} direction="vertical">
      <Row justify="end">
        <Button type="default" onClick={onFilter}>
          {t("common.filter")} <FilterOutlined />
        </Button>
      </Row>
      <CardContainer>
        <div style={{ height: 200, padding: "1rem" }}>ASSESSMENT RESULTS</div>
      </CardContainer>
    </Space>
  );
}

export default EmployeePerformanceAssessmentResults;
